import Vue from 'vue';
import Vuex from 'vuex';
import getters from './getter';
Vue.use(Vuex);
// https://webpack.js.org/guides/dependency-management/#requirecontext
const modulesFiles = require.context('./modules', false, /\.js$/);
// 您不需要从“./modules/app”导入应用程序。`
// 它将自动要求模块文件中的所有Vuex模块
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
    // set './app.js' => 'app'
    const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1');
    const value = modulesFiles(modulePath);
    modules[moduleName] = value.default;
    return modules
}, {});

const store = new Vuex.Store({
    modules,
    getters,
});

export default store;
